import React, { useState, useEffect, useContext } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import 'bootstrap/dist/css/bootstrap.min.css';
import Alert from 'react-s-alert';
import baseURL from '../Common/Config';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import Pages from '../Common/AppPages';
import { CallBackAlert } from '../Common/Validations/validation';
import IsUndefinedNullOrEmpty from '../Common/Validations/valueCheck';

const RoleAccess = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    const [Roles, setRoles] = useState([]);
    const [RoleAccess, setRoleAccess] = useState([]);
    const [SelectedRole, setSelectedRole] = useState("");
    const [Counter, setCounter] = useState(0);

    useEffect(() => {
        if (Roles.length === 0) {
            FetchRoles();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Counter]);

    const FetchRoles = () => {
        Axiosfetch(baseURL + "GetActiveRoles", "GET", null, RolesSuccess, Failure);
    };

    const RolesSuccess = (data) => {
        if (data.length > 0) {
            let rolesData = [];
            data.forEach(roles => {
                rolesData.push({ value: roles._id, label: roles.Name });
            });
            setRoles(rolesData);
        }
        else {
            setRoles([]);
        }
    };

    const SelectedRolesChange = (SelectedRoles) => {
        let Role = SelectedRoles ? SelectedRoles.value : "";
        if (!IsUndefinedNullOrEmpty(Role)) {
            setSelectedRole(Role);
            FetchRolePages(Role);
        }
        else {
            setSelectedRole("");
            setRoleAccess([]);
        }
    };

    const FetchRolePages = (Role) => {
        Axiosfetch(baseURL + "GetRoleAccessByRoleID", "POST", { RoleID: Role }, RolePageSuccess, Failure);
    };

    const RolePageSuccess = (data) => {
        if (data.length > 0) {
            setRoleAccess(data);
        }
        else {
            setRoleAccess([]);
        }
    }

    const SaveRolePages = () => {
        var dd = document.querySelectorAll(".switch-input");
        var userData = localStorage.getItem("userData") ? localStorage.getItem("userData") : null;
        if (userData) {
            const userID = JSON.parse(userData)._id;
            var PageData = [];
            for (var i = 0; i < dd.length; i++) {
                if (dd[i].checked) {
                    let PageNumber = dd[i].id.trim().replace("switch-", "");
                    if (!isNaN(PageNumber) && dd[i].attributes.pagename !== undefined) {
                        PageData.push({
                            RoleID: SelectedRole,
                            PageID: parseInt(PageNumber),
                            PageName: dd[i].attributes.pagename.value.trim(),
                            CreatedBy: userID,
                            //CreatedDate: moment(new Date()).format('MM/DD/YYYY, HH:mm:ss'),
                            // Status: 1,
                            // IsDeleted: 0
                        });
                    }
                }
            }

            if (PageData.length > 0) {
                Axiosfetch(baseURL + "CreateRoleAccess", "POST", PageData, RolePageAddSuccess, Failure);
            }
            else {
                Alert.error("Please select at least one Page", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
    };

    const SaveRoleAccess = () => {
        var isPageSelected = false;
        var dd = document.querySelectorAll(".switch-input");
        for (let i = 0; i < dd.length; i++) {
            if (dd[i].checked) {
                isPageSelected = true;
                break;
            }
        }

        if (!isPageSelected) {
            Alert.error("Please select at least one Page", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
        else if (!IsUndefinedNullOrEmpty(SelectedRole)) {
            Axiosfetch(baseURL + "DeleteRoleAcess", "POST", { RoleID: SelectedRole }, RolePageDeleteSuccess, Failure);
        }
        else {
            Alert.error("Please select Role", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const RolePageDeleteSuccess = (data) => {
        if (data.success) {
            SaveRolePages();
        }
        else {
            Alert.error("Error Saving Role Access", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }

    };

    const RolePageAddSuccess = (result) => {
        if (result.success) {
            if (SelectedRole !== "") {
                RolePageSuccess(result.data);
            }
        }

        CallBackAlert(result);
    };

    const OnCheckChange = (e) => {
        let draftAccess = RoleAccess;
        let PageNumber = e.target.id.trim().replace("switch-", "");
        if (e.target.checked) {
            if (!isNaN(PageNumber)) {
                draftAccess.push({ PageID: parseInt(PageNumber), PageName: e.target.attributes.pagename.value.trim() });
                setRoleAccess(draftAccess);
                setCounter(Counter + 1);
            }
        }
        else {
            draftAccess = draftAccess.filter(r => r.PageID !== parseInt(PageNumber));
            setRoleAccess(draftAccess);
            setCounter(Counter + 1);
        }
    };

    const OnAllSelecthange = (e) => {
        if (!IsUndefinedNullOrEmpty(SelectedRole)) {
            var dd = document.querySelectorAll(".switch-input");
            for (let i = 0; i < dd.length; i++) {
                dd[i].checked = e.target.checked;
            }

            if (!e.target.checked) {
                setRoleAccess([]);
            }
        }
        else {
            Alert.error("Please select a Role.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme sidemenu-show">
                <div className="row">
                    <div className="col-md-2 col-sm-2">
                        <span><input id="allselected" style={{ marginRight: "4px" }} type="checkbox" onChange={e => OnAllSelecthange(e)}></input>Select All</span>
                    </div>
                    <div className="offset-md-2 col-md-3 col-sm-3">
                        <div className="align-center" style={{ fontWeight: "500", fontSize: "25px" }}>Role Access</div>
                    </div>
                    <div className="col-md-4 col-10">
                        <div>
                            <Select isClearable={true} isSearchable={true} placeholder="Select Role"
                                options={Roles}
                                onChange={SelectedRolesChange}></Select>
                        </div>
                    </div>
                    <div className="col-md-1 col-sm-1 col-2">
                        <span data-tip="Save Role Access" className={`cursor font-size-15rem addIconFocus ${CurrentTheme}Color`} onClick={SaveRoleAccess}>
                            <FontAwesomeIcon icon={faSave} />
                        </span>
                    </div>
                </div>
                <div className="row" style={{ paddingTop: "5px" }}>
                    <div className="offset-md-1 col-md-11">
                        <div className="PageHeight" style={{ padding: "10px", scrollbarColor: "#005582 transparent" }}>
                            <div className="row">
                                {<div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>Quotation List</div>
                                    {Pages.QuotationList.length > 0 && Pages.QuotationList.map(QuotationPage => (
                                        <div key={QuotationPage.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={RoleAccess.filter(r => r.PageID === QuotationPage.ID).length > 0}
                                                    onChange={OnCheckChange} id={`switch-${QuotationPage.ID}`} pagename={QuotationPage.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${QuotationPage.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{QuotationPage.Name}</span>
                                        </div>
                                    ))}
                                </div>}
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>Configuration List</div>
                                    {Pages.ConfigList.length > 0 && Pages.ConfigList.map(ConfigPage => (
                                        <div key={ConfigPage.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === ConfigPage.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${ConfigPage.ID}`} pagename={ConfigPage.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${ConfigPage.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{ConfigPage.Name}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>Enquiry</div>
                                    {Pages.EnquiryList.length > 0 && Pages.EnquiryList.map(enquiry => (
                                        <div key={enquiry.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === enquiry.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${enquiry.ID}`} pagename={enquiry.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${enquiry.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{enquiry.Name}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>LR</div>
                                    {Pages.LRDocList.length > 0 && Pages.LRDocList.map(lr => (
                                        <div key={lr.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === lr.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${lr.ID}`} pagename={lr.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${lr.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{lr.Name}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>Invoice List</div>
                                    {Pages.InvoiceList.length > 0 && Pages.InvoiceList.map(InvoicePage => (
                                        <div key={InvoicePage.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === InvoicePage.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${InvoicePage.ID}`} pagename={InvoicePage.Page}
                                                    type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${InvoicePage.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{InvoicePage.Name}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>Service Request</div>
                                    {Pages.ServReqList.length > 0 && Pages.ServReqList.map(serv => (
                                        <div key={serv.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === serv.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${serv.ID}`} pagename={serv.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${serv.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{serv.Name}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>Tracking</div>
                                    {Pages.TrackingList.length > 0 && Pages.TrackingList.map(track => (
                                        <div key={track.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === track.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${track.ID}`} pagename={track.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${track.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{track.Name}</span>
                                        </div>
                                    ))}
                                </div>
                                <div className="col-md-3 col-sm-4 col-5" style={{ border: "1px solid #ccc", margin: "10px", borderRadius: "6px" }}>
                                    <div style={{ borderRadius: "0 0 10px 10px", textAlign: "center" }} className={`RoleAccessHeaders ${CurrentTheme}`}>DashBoard</div>
                                    {Pages.DashBoardList.length > 0 && Pages.DashBoardList.map(dashboard => (
                                        <div key={dashboard.ID} style={{ padding: "8px", borderBottom: "1px solid #ccc" }}>
                                            <div className="switch">
                                                <input checked={(RoleAccess.length > 0 && RoleAccess.filter(r => r.PageID === dashboard.ID).length > 0)}
                                                    onChange={OnCheckChange} id={`switch-${dashboard.ID}`} pagename={dashboard.Page} type="checkbox" className="switch-input" />
                                                <label htmlFor={`switch-${dashboard.ID}`} className="switch-label">Switch</label>
                                            </div>
                                            <span style={{ paddingLeft: "10px" }}>{dashboard.Name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleAccess;